export default function initAccordion() {
  document.querySelectorAll(".accordion-item").forEach((item) => {
    const text = item.querySelector(".accordion-text");

    text.style.maxHeight = "0px";

    item.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      if (isOpen) {
        text.style.maxHeight = "0px";
      } else {
        text.style.maxHeight = `${text.scrollHeight + 20}px`;
      }

      item.classList.toggle("active");
    });
  });
}
